<template>
  <v-container fluid class="pa-0 pa-sm-4">
    <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>

    <v-alert v-if="error" type="error" dense class="mb-4">
      Error loading bookings: {{ error.message }}
    </v-alert>

    <v-card v-if="!isLoading && !error" class="pa-0 pa-sm-4 glass-card" elevation="0" rounded="xl">
      <v-sheet class="bg-transparent mb-2" tile>
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="auto" class="mb-2 mb-sm-0">
            <v-btn color="green" @click="dialogadd = true">ทำการจอง</v-btn>
          </v-col>
          <v-col cols="12" sm="auto" class="text-center order-last order-sm-0 mb-2 mb-sm-0">
            <!-- <v-toolbar-title class="text-subtitle-1 text-sm-h5 font-weight-bold">
              {{ vuecalRef ? vuecalRef.viewTitle : "" }}
            </v-toolbar-title> -->
          </v-col>
          <v-col cols="auto">
            <v-select v-model="activeView" :items="options" label="มุมมอง" item-title="text" item-value="value"
              variant="outlined" density="compact" max-width="120px" hide-details></v-select>
          </v-col>
        </v-row>
      </v-sheet>
      <vue-cal ref="vuecalRef" style="height: 70vh" :events="calendarEvents" :active-view="activeView"
        events-on-month-view hide-view-selector :disable-views="['years', 'year']" @event-click="onEventClick"
        start-week-on-sunday small></vue-cal>
    </v-card>
    <v-dialog v-model="showEventDialog" max-width="1100">
      <v-card v-if="selectedEvent" rounded="lg">
        <v-toolbar :color="getEventColor(selectedEvent)" dark>
          <v-toolbar-title>{{ selectedEvent.props.room }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon size="small" @click="showEventDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="py-4">
          <div class="text-subtitle-1 mb-1">
            เวลา: {{ formatEventTime(selectedEvent.start) }} ถึง
            {{ formatEventTime(selectedEvent.end) }}
          </div>
          <!-- <div class="text-subtitle-1 mb-1">
            เวลา: {{ selectedEvent.start }} ถึง
            {{ selectedEvent.end }}
          </div> -->

          <div class="text-subtitle-1 mb-1">
            จองโดย: {{ selectedEvent.props.bookBy || "N/A" }}
          </div>
          <div :class="[
            'text-subtitle-1',
            getDetailClass(selectedEvent.props.status),
          ]">
            สถานะผู้จอง: {{ selectedEvent.props.status || "N/A" }}
          </div>
          <div v-if="selectedEvent.props.note" class="text-body-2 mt-2">
            <strong>หมายเหตุ:</strong> {{ selectedEvent.props.note }}
          </div>
          <div v-if="selectedEvent.props.sNote" class="text-body-2 mt-2">
            <strong>หมายเหตุ:</strong> {{ selectedEvent.props.sNote }}
          </div>
          <div v-if="selectedEvent.props.purpose" class="text-body-2">
            <strong>วัตถุประสงค์การใช้ห้อง:</strong>
            {{ formatNotes(selectedEvent.props.purpose) }}
          </div>
        </v-card-text>
        <v-card-actions class="align-start">
          <v-spacer></v-spacer>
          <v-btn v-if="
            (selectedEvent && selectedEvent.props.bId === user.uid) ||
            user.role === 'admin'
          " color="red" variant="tonal" prepend-icon="mdi-delete-empty" @click="showCancelConfirmDialog = true">
            ยกเลิกการจอง
          </v-btn>
          <v-btn color="primary" variant="tonal" @click="showEventDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogadd" width="100%" max-width="1300" class="py-2">
      <v-card max-width="1300" prepend-icon="mdi-account-plus" rounded="lg" class="elevation-10 mb-5 p-0">
        <v-card-text class="my-0">
          <v-container class="py-2">
            <v-row justify="start" align="start">
              <v-col cols="12">
                <addevent @emit_userform="adduser" @close-dialog="handleclosedialog" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <template v-slot:actions>
          <v-btn class="mb-3 mr-3" variant="outlined" elevation="3" color="red" text="ปิด"
            @click="dialogadd = false"></v-btn>
        </template>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showCancelConfirmDialog" max-width="500">
      <v-card>
        <v-card-title class="headline text-red">ยืนยันการยกเลิก</v-card-title>
        <v-card-text>
          คุณต้องการยกเลิกการจองนี้ใช่หรือไม่? การกระทำนี้ไม่สามารถย้อนกลับได้.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="showCancelConfirmDialog = false">ยกเลิก</v-btn>
          <v-btn color="red" text @click="cancelBooking">ยืนยันการยกเลิก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import { computed, ref, onMounted, watch } from "vue";
import { useNurseData } from "@/useNurseData";
import { useAuth } from "@/composable";
import addevent from "./addevent.vue";
import { db } from "@/firebaseConfig";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { initializeAuth } from "@/composable";
initializeAuth();

const { nurseItems, isLoading, error, fetchNurseData } = useNurseData();
const vuecalRef = ref(null);
const activeView = ref("month");
const viewOptions = ["month", "week", "day"];
const options = ref([
  { text: "เดือน", value: "month" },
  { text: "สัปดาห์", value: "week" },
  { text: "วัน", value: "day" },
]);
const showEventDialog = ref(false);
const selectedEvent = ref(null);
const showCancelConfirmDialog = ref(false);

const cancelBooking = async () => {
  const bookingId = selectedEvent.value.props.id;

  if (!selectedEvent.value || !selectedEvent.value.props.id) {
    console.error("No selected event or event ID found for cancellation.");
    alert("เกิดข้อผิดพลาด: ไม่พบข้อมูลการจอง", "error");
    return;
  }

  const docRef = doc(db, "booking", bookingId);
  try {
    await updateDoc(docRef, {
      bookStatus: "cancel",
    });
    alert("การจองถูกยกเลิกเรียบร้อยแล้ว", "success");
    showCancelConfirmDialog.value = false;
    showEventDialog.value = false;
    await fetchNurseData();
  } catch (err) {
    console.error("Error cancelling booking:", err);
    alert(`เกิดข้อผิดพลาดในการยกเลิก: ${err.message}`, "error");
  }
};

onMounted(() => {
  fetchNurseData();
});
const {
  drawer,
  user,
  rail,
  logout,
  isAuthenticated,
  snackbar,
  snackbarColor,
  snackbarMessage,
} = useAuth();

// --- BEGIN CORRECTED CODE ---
const calendarEvents = computed(() => {
  if (!nurseItems.value) return [];

  // 1. Group events by a more precise key
  const groupedEvents = nurseItems.value.reduce((acc, booking) => {
    // We use a combined key: bId + room + status
    const key = `${booking.bId || ""}-${booking.room || ""}-${booking.status || ""
      }`;
    if (!key) return acc;

    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(booking);
    return acc;
  }, {});

  const finalEvents = [];

  // 2. Iterate and merge contiguous events
  for (const key in groupedEvents) {
    const bookings = groupedEvents[key];

    // Sort by start date to process them chronologically
    // start/end are already JS Date objects from useNurseData
    const sortedBookings = bookings.sort(
      (a, b) => (a.start instanceof Date ? a.start.getTime() : new Date(a.start).getTime()) -
                 (b.start instanceof Date ? b.start.getTime() : new Date(b.start).getTime())
    );

    let currentMergeGroup = [sortedBookings[0]];

    for (let i = 1; i < sortedBookings.length; i++) {
      const prevBooking = sortedBookings[i - 1];
      const currentBooking = sortedBookings[i];

      const prevEnd   = prevBooking.end   instanceof Date ? prevBooking.end   : new Date(prevBooking.end);
      const currStart = currentBooking.start instanceof Date ? currentBooking.start : new Date(currentBooking.start);

      // Check if current booking is on the day immediately following the previous one
      const prevEndDay = prevEnd.getDate();
      const currentStartDay = currStart.getDate();
      const prevEndMonth = prevEnd.getMonth();
      const currentStartMonth = currStart.getMonth();
      const prevEndYear = prevEnd.getFullYear();
      const currentStartYear = currStart.getFullYear();

      const isContiguous =
        prevEndYear === currentStartYear &&
        prevEndMonth === currentStartMonth &&
        prevEndDay + 1 === currentStartDay;

      // Also check if the times are consistent
      const prevEndTime = prevEnd.toLocaleTimeString();
      const currentStartTime = currStart.toLocaleTimeString();
      const isSameTime = prevEndTime === currentStartTime;

      if (isContiguous && isSameTime) {
        // If it's a contiguous booking, add it to the current group
        currentMergeGroup.push(currentBooking);
      } else {
        // If not, finalize the current group and start a new one
        finalizeAndAddGroup(currentMergeGroup, finalEvents);
        currentMergeGroup = [currentBooking];
      }
    }

    // Finalize the last group
    if (currentMergeGroup.length > 0) {
      finalizeAndAddGroup(currentMergeGroup, finalEvents);
    }
  }

  // Helper function to create a single event from a group
  function finalizeAndAddGroup(group, eventsArray) {
    const firstEvent = group[0];
    const lastEvent = group[group.length - 1];

    eventsArray.push({
      start: firstEvent.start,
      end: lastEvent.end,
      title: `${firstEvent.room} `,
      class: `status-${firstEvent.status}`,
      props: {
        id: firstEvent.id,
        status: firstEvent.status,
        note: firstEvent.note,
        purpose: firstEvent.purpose,
        room: firstEvent.room,
        bookBy: firstEvent.bookBy,
        bId: firstEvent.bId,
        bStatus: firstEvent.bStatus,
        sNote: firstEvent.sNote,
      },
    });
  }

  return finalEvents;
});
// --- END CORRECTED CODE ---

// Watcher to synchronize v-select with vue-cal's active view
watch(activeView, (newView) => {
  if (vuecalRef.value) {
    vuecalRef.value.switchView(newView);
  }
});
const handleclosedialog = () => {
  dialogadd.value = false;
  location.reload();
};
// Helper function to format time for display
const formatEventTime = (date) => {
  if (!date || isNaN(new Date(date).getTime())) return "N/A";
  const dateObj = new Date(date);
  const time = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  // if (
  //   selectedEvent.value &&
  //   new Date(date).getDate() !== new Date(selectedEvent.value.start).getDate()
  // )

  return dateObj.toLocaleDateString("th-TH") + " " + time;

  return time;
};

// Helper to get CSS class for detail status in dialog
const getDetailClass = (status) => {
  return `detail-status-${status}`;
};

const formatNotes = (notes) => {
  if (Array.isArray(notes)) {
    return notes.join(", ");
  }
  return notes || "";
};
// Helper to get color for event or dialog header
const getEventColor = (event) => {
  const status = event.props.status;
  if (status === "อาจารย์") {
    return "blue";
  } else if (status === "นักศึกษา" || status === "นักเรียน") {
    return "#fda9fde8";
  } else if (status === "บุคลากร") {
    return "#bdf5f7";
  }
  return "blue";
};

const onEventClick = (event, domEvent) => {
  domEvent.stopPropagation();
  selectedEvent.value = event;
  showEventDialog.value = true;
};
const dialogadd = ref(false);
</script>

<style>
/* Base VueCal container height */
.vuecal {
  height: 70vh;
}

/* Base styles for all vuecal events to allow content flexibility */
/* CRITICAL FIX: Ensure min-height is sufficient and layout is column */
.vuecal__event {
  border-radius: 8px;
  min-height: 50px;
  /* Provides enough space for title, time, status lines */
  padding: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /* Stack event content vertically */
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  /* Important for clipping long text */
  cursor: pointer;
  /* Indicates event is clickable */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.vuecal__event:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Wrapper for content inside the event slot */
.vuecal__event-content-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

/* Styles for individual lines within the custom event content */
.vuecal__event-title {
  font-weight: bold;
  font-size: 0.85em;
  /* Adjusted font size for better fit */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Add ellipsis for clipped text */
  line-height: 1.2;
}

.vuecal__event-time {
  font-size: 0.75em;
  /* Smaller font for time */
  opacity: 0.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.vuecal__event-details {
  font-size: 0.7em;
  /* Even smaller for details */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

/* Your status-based background colors */
.vuecal__event.status-บุคลากร {
  background: linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%) !important;
  border-left: 4px solid #00897b !important;
  color: #004d40 !important;
}

.vuecal__event.status-นักศึกษา,
.vuecal__event.status-นักเรียน {
  background: linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%) !important;
  border-left: 4px solid #c2185b !important;
  color: #880e4f !important;
}

.vuecal__event.status-อาจารย์ {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
  border-left: 4px solid #1976d2 !important;
  color: #0d47a1 !important;
}

.vuecal__event.status-unknown {
  /* Added for robustness if status is missing */
  background-color: #eceff1 !important;
  border-left: 4px solid #90a4ae !important;
  color: #424242 !important;
}

/* Text colors for details (in event content and dialog) */
.detail-status-นักศึกษา,
.detail-status-นักเรียน {
  color: #e65100 !important;
}

.detail-status-บุคลากร {
  color: #1b5e20 !important;
}

.detail-status-อาจารย์ {
  color: #1565c0 !important;
}

.detail-status-unknown {
  color: #757575 !important;
}

/* --- Specific month view layout adjustments --- */

/* Ensure day number is visible and not reversed in order *if* you want it above events */
/* If you had `flex-direction: row-reverse;` it would reverse the order of elements in the cell */
.vuecal .vuecal__cell--has-events {
  flex-direction: column;
  /* Standard stacking for date and events */
  justify-content: flex-start;
  overflow: hidden;
  padding-top: 5px;
  /* Add some top padding to cells */
}

/* Ensure cell-date is at the start (top-left by default for column flex) */
.vuecal .vuecal__cell--has-events .vuecal__cell-date {
  align-self: flex-start;
  padding-left: 5px;
  /* Add some padding to align date with events */
  margin-bottom: 5px;
  /* Space between date and first event */
}

/* Hide vue-cal's default top menu/view selector if using your custom one */
.vuecal__menu {
  display: none !important;
}

.glass-card {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 16px 32px 0 rgba(31, 38, 135, 0.1) !important;
}

.bg-transparent {
  background: transparent !important;
}
</style>

<style>
@media (max-width: 600px) {
  .vuecal__event {
    min-height: 28px;
    padding: 4px 2px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100% !important;
    margin: 0 !important;
  }

  .vuecal__event-time {
    display: none !important;
  }

  .vuecal__event-details {
    display: none !important;
  }

  .vuecal__event-title {
    font-size: 0.7em;
    text-align: left;
    width: 100%;
  }

  .vuecal {
    height: 80vh !important;
  }
}
</style>
